import React from "react";

const TransfersTabs = ({ activeTab, onTabClick }) => {
  return (
    <div className="d-flex justify-content-start mt-3">
      <button
        className={`btn transferbtn me-2 ${activeTab === "transfers" ? "active" : ""}`}
        onClick={() => onTabClick("transfers")}
      >
        Transfers
      </button>
      <button
        className={`btn transferbtn ${activeTab === "unclaimed" ? "active" : ""}`}
        onClick={() => onTabClick("unclaimed")}
      >
        Unclaimed Requests
      </button>
    </div>
  );
};

export default TransfersTabs;

